module.exports = __webpack_public_path__ + "img/medium_brown.0ba9177f.svg";